import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AccountResponse, BankAccountTypesResponse } from 'src/app/models/account.model';
import { BamBankTransferLog } from 'src/app/models/bam-log';
import { ResponseObject } from 'src/app/models/response-object.model';
import { VendorBankRequest } from 'src/app/models/vendor.model';
import { BamTransferServiceService } from 'src/app/services/bam-transfer-service.service';

interface BamBankTransferLogResponse {
  bamBankTransferLog: BamBankTransferLog;
  bankDebit: AccountResponse;
  bankCredit: AccountResponse;
  vendorBankCredit: VendorBankRequest;
  vendorBank: boolean;
  sourceBankName: string;
  sourceAccountType: string;
  destinationBankName: string;
  destinationAccountType: string;
}

export interface BamBatchStatus {
  code: string;
  name: string;
  description: string;
}

export const BAM_BATCH_STATUS_MAP: Record<string, BamBatchStatus> = {
  CN: { code: 'CN', name: 'CANCELADA', description: 'Lote finalizado' },
  IN: { code: 'IN', name: 'INGRESADO', description: 'Lote en ejecución' },
  VA: { code: 'VA', name: 'VALIDANDO', description: 'Lote en ejecución' },
  LI: { code: 'LI', name: 'LOTE INVALIDO', description: 'Lote finalizado' },
  VD: { code: 'VD', name: 'VALIDADO', description: 'Lote en ejecución' },
  LE: { code: 'LE', name: 'LISTO PARA EJECUTAR', description: 'Lote en ejecución' },
  MI: { code: 'MI', name: 'METADATA INVALIDA', description: 'Lote finalizado' },
  EI: { code: 'EI', name: 'ESTADO INVALIDO', description: 'Lote finalizado' },
  EJ: { code: 'EJ', name: 'EJECUTADA', description: 'Lote finalizado' },
  ER: { code: 'ER', name: 'EJECUTADA CON ERRORES', description: 'Lote finalizado' },
  EE: { code: 'EE', name: 'EN EJECUCION', description: 'Lote en ejecución' },
  FD: { code: 'FD', name: 'FALLIDA', description: 'Lote finalizado' },
  PG: { code: 'PG', name: 'PROGRAMADA', description: 'Lote pendiente de ejecución' },
  RZ: { code: 'RZ', name: 'RECHAZADA', description: 'Lote finalizado' },
  VN: { code: 'VN', name: 'VENCIDA', description: 'Lote finalizado' }
};

@Component({
  selector: 'app-bam-transfer-history',
  templateUrl: './bam-transfer-history.component.html',
  styleUrls: ['./bam-transfer-history.component.scss']
})
export class BamTransferHistoryComponent implements OnInit {

  startDate = new Date().toLocaleDateString('en-CA');
  endDate = new Date().toLocaleDateString('en-CA');
  pagination = {
    total: [] as BamBankTransferLogResponse[], // todos los registros traídos
    filter: [] as BamBankTransferLogResponse[], // registros visibles en la página actual
    pageSize: 10,
    startElement: 0,
    lastElement: 0,
    pageIndex: 0
  };
  accountFilter: string = "";
  loading = false;

  constructor(private bamTransferServiceService: BamTransferServiceService,
    private toastrService: ToastrService) { }

  ngOnInit(): void {
    this.getTransfers();
  }

  getTransfers() {
    this.loading = true;
    this.bamTransferServiceService.getHistory(this.startDate, this.endDate).subscribe({
      next: (res: ResponseObject) => {
        this.pagination.total = res.data;
        this.updateFilter();
        this.loading = false;
      },
      error: (error: HttpErrorResponse) => {
        this.loading = false;
        this.toastrService.error("Error", "No se puedo obtener el historial de transferencias");
      }
    });
  }

  updateFilter() {
    let data = [...this.pagination.total]; // o la lista completa de transfers cargados

    // Filtro por número de cuenta
    if (this.accountFilter && this.accountFilter.trim() !== "") {
      const accountSearch = this.accountFilter.trim().toLowerCase();
      data = data.filter(t =>
        (t.bankDebit.accountNumber + '').toLowerCase().includes(accountSearch) ||
        (t.bankCredit != null && (t.bankCredit.accountNumber + '').toLowerCase().includes(accountSearch)) ||
        (t.vendorBankCredit != null && (t.vendorBankCredit.accountNumber + '').toLowerCase().includes(accountSearch))
      );
    }

    this.pagination.total = data;
    this.resetPagination();
  }

  resetPagination() {
    this.pagination.filter = this.pagination.total.slice(0, this.pagination.pageSize);
    this.pagination.pageIndex = 0;
    this.pagination.lastElement = this.pagination.filter.length;
    this.pagination.startElement = 0;
  }

  changePage(pageIndex: number) {
    this.pagination.pageIndex = pageIndex;
    const start = pageIndex * this.pagination.pageSize;
    const end = start + this.pagination.pageSize;
    this.pagination.filter = this.pagination.total.slice(start, end);
    this.pagination.startElement = start;
    this.pagination.lastElement = this.pagination.filter.length;
  }

  convertToString(dateStr: string | undefined): string {
    if (!dateStr) return '-';
    const date = new Date(dateStr);
    return date.toLocaleString('es-GT', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  }

  formatCreatedAt(createdAt: any): string {
    if (!createdAt) return '-';

    const day = createdAt.dayOfMonth.toString().padStart(2, '0');
    const month = createdAt.monthValue.toString().padStart(2, '0');
    const year = createdAt.year;

    const hour = createdAt.hour.toString().padStart(2, '0');
    const minute = createdAt.minute.toString().padStart(2, '0');
    const second = createdAt.second.toString().padStart(2, '0');

    return `${day}/${month}/${year} ${hour}:${minute}:${second}`;
  }

  status(code: string): BamBatchStatus | null {
    return BAM_BATCH_STATUS_MAP[code] || null;
  }
}
